module.exports = __webpack_public_path__ + "static/media/fenster_auf.ce794afd.jpg";